import { render, staticRenderFns } from "./alarmRecord.vue?vue&type=template&id=d0c4ea9c&scoped=true&"
import script from "./alarmRecord.vue?vue&type=script&lang=js&"
export * from "./alarmRecord.vue?vue&type=script&lang=js&"
import style0 from "./alarmRecord.vue?vue&type=style&index=0&id=d0c4ea9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c4ea9c",
  null
  
)

export default component.exports